export const LOAD_SITE_SCHEDULES = 'LOAD_SITE_SCHEDULES'
export const SITE_SCHEDULE_ADDED = 'SITE_SCHEDULE_ADDED'
export const SITE_SCHEDULE_REMOVED = 'SITE_SCHEDULE_REMOVED'



// WEBPACK FOOTER //
// ./src/modules/schedules/action-types.js